:root {
  --pinepost-paper: #fff8ea;
  --pinepost-paper-raised: #fffdf5;
  --pinepost-ink: #2f3b2f;
  --pinepost-muted: #69745f;
  --pinepost-border: #ccb98b;
  --pinepost-border-strong: #8c7147;
  --pinepost-leaf: #4f8f5f;
  --pinepost-leaf-dark: #356841;
  --pinepost-moss: #d8e3b5;
  --pinepost-stamp: #c9624b;
  --pinepost-stamp-dark: #983f33;
  --pinepost-parcel: #c58b4b;
  --pinepost-sky: #87b9c9;
  --pinepost-focus: #2f7fa0;
  --pinepost-shadow: rgba(71, 55, 30, 0.18);
  --pinepost-ring: rgba(47, 127, 160, 0.34);
  --pinepost-radius-xs: 4px;
  --pinepost-radius-sm: 6px;
  --pinepost-radius-md: 8px;
  --pinepost-font: "Trebuchet MS", "Avenir Next", "Segoe UI", sans-serif;
}

[data-pinepost-theme="calm"] {
  --pinepost-paper: #fff8ea;
  --pinepost-paper-raised: #fffdf5;
  --pinepost-ink: #2f3b2f;
  --pinepost-muted: #69745f;
  --pinepost-border: #ccb98b;
  --pinepost-border-strong: #8c7147;
  --pinepost-leaf: #4f8f5f;
  --pinepost-leaf-dark: #356841;
  --pinepost-moss: #d8e3b5;
  --pinepost-stamp: #c9624b;
  --pinepost-stamp-dark: #983f33;
  --pinepost-parcel: #c58b4b;
  --pinepost-sky: #87b9c9;
  --pinepost-focus: #2f7fa0;
}

[data-pinepost-theme="play"] {
  --pinepost-paper: #fff3d7;
  --pinepost-paper-raised: #fffaf0;
  --pinepost-ink: #263728;
  --pinepost-muted: #687656;
  --pinepost-border: #d4ac66;
  --pinepost-border-strong: #8a6536;
  --pinepost-leaf: #3f9f70;
  --pinepost-leaf-dark: #256d47;
  --pinepost-moss: #cde986;
  --pinepost-stamp: #d9536b;
  --pinepost-stamp-dark: #a8324d;
  --pinepost-parcel: #e09b42;
  --pinepost-sky: #7bc9d7;
  --pinepost-focus: #286fd1;
}

[data-pinepost-theme="shop"] {
  --pinepost-paper: #fff0dc;
  --pinepost-paper-raised: #fff8ed;
  --pinepost-ink: #3a3229;
  --pinepost-muted: #7d6653;
  --pinepost-border: #d1a46c;
  --pinepost-border-strong: #8f6135;
  --pinepost-leaf: #4e8c68;
  --pinepost-leaf-dark: #356547;
  --pinepost-moss: #e7d78f;
  --pinepost-stamp: #c44e3d;
  --pinepost-stamp-dark: #923529;
  --pinepost-parcel: #d88937;
  --pinepost-sky: #8fb9bd;
  --pinepost-focus: #8f4b2c;
}

.pinepost-root {
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
}

.pinepost-root *,
.pinepost-root *::before,
.pinepost-root *::after {
  box-sizing: border-box;
}

.pinepost-button {
  align-items: center;
  border: 2px solid transparent;
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border-strong), 0 9px 18px var(--pinepost-shadow);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-weight: 800;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1;
  min-width: max-content;
  position: relative;
  text-decoration: none;
  transform: translateY(0);
  transition: background-color 160ms ease, box-shadow 160ms ease, color 160ms ease, transform 160ms ease;
  user-select: none;
  white-space: nowrap;
}

.pinepost-button:hover {
  transform: translateY(-1px);
}

.pinepost-button:active {
  box-shadow: 0 1px 0 var(--pinepost-border-strong), 0 4px 10px var(--pinepost-shadow);
  transform: translateY(2px);
}

.pinepost-button:focus-visible,
.pinepost-input:focus-visible,
.pinepost-textarea:focus-visible,
.pinepost-checkbox:focus-visible,
.pinepost-switch:focus-visible,
.pinepost-tabs__trigger:focus-visible,
.pinepost-toast__action:focus-visible,
.pinepost-toast__close:focus-visible {
  outline: 3px solid var(--pinepost-ring);
  outline-offset: 3px;
}

.pinepost-button:disabled,
.pinepost-button[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.58;
  transform: none;
}

.pinepost-button--sm {
  font-size: 0.82rem;
  min-height: 34px;
  padding: 0 12px;
}

.pinepost-button--md {
  font-size: 0.95rem;
  min-height: 42px;
  padding: 0 16px;
}

.pinepost-button--lg {
  font-size: 1.05rem;
  min-height: 50px;
  padding: 0 22px;
}

.pinepost-button--primary {
  background: linear-gradient(180deg, color-mix(in srgb, var(--pinepost-leaf) 88%, white), var(--pinepost-leaf));
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-button--soft {
  background:
    repeating-linear-gradient(90deg, transparent 0 9px, rgba(255, 255, 255, 0.28) 9px 10px),
    var(--pinepost-moss);
  border-color: color-mix(in srgb, var(--pinepost-leaf-dark) 64%, white);
  color: var(--pinepost-ink);
}

.pinepost-button--stamp {
  background: var(--pinepost-stamp);
  border-color: var(--pinepost-stamp-dark);
  color: #fff9ef;
  outline: 1px dashed rgba(255, 255, 255, 0.52);
  outline-offset: -6px;
}

.pinepost-button--parcel {
  background:
    linear-gradient(90deg, transparent 46%, rgba(92, 58, 30, 0.18) 46% 54%, transparent 54%),
    var(--pinepost-parcel);
  border-color: var(--pinepost-border-strong);
  color: #352619;
}

.pinepost-card {
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.42), transparent 42%),
    repeating-linear-gradient(0deg, transparent 0 13px, rgba(85, 65, 35, 0.045) 13px 14px),
    var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 color-mix(in srgb, var(--pinepost-border) 72%, var(--pinepost-border-strong)), 0 16px 30px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  overflow: hidden;
}

.pinepost-card__header,
.pinepost-card__content,
.pinepost-card__footer {
  padding: 18px;
}

.pinepost-card__header {
  border-bottom: 1px dashed color-mix(in srgb, var(--pinepost-border) 80%, transparent);
}

.pinepost-card__footer {
  align-items: center;
  border-top: 1px dashed color-mix(in srgb, var(--pinepost-border) 80%, transparent);
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.pinepost-card__title {
  font-size: 1.08rem;
  line-height: 1.25;
  margin: 0;
}

.pinepost-card__description {
  color: var(--pinepost-muted);
  font-size: 0.94rem;
  line-height: 1.45;
  margin: 7px 0 0;
}

.pinepost-badge {
  align-items: center;
  border: 1px solid transparent;
  border-radius: var(--pinepost-radius-sm);
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1;
  min-height: 24px;
  padding: 0 9px;
  white-space: nowrap;
}

.pinepost-badge--leaf {
  background: color-mix(in srgb, var(--pinepost-leaf) 22%, white);
  border-color: color-mix(in srgb, var(--pinepost-leaf-dark) 52%, white);
  color: var(--pinepost-leaf-dark);
}

.pinepost-badge--stamp {
  background: color-mix(in srgb, var(--pinepost-stamp) 18%, white);
  border-color: color-mix(in srgb, var(--pinepost-stamp-dark) 52%, white);
  color: var(--pinepost-stamp-dark);
}

.pinepost-badge--parcel {
  background: color-mix(in srgb, var(--pinepost-parcel) 24%, white);
  border-color: color-mix(in srgb, var(--pinepost-border-strong) 50%, white);
  color: #60421f;
}

.pinepost-badge--sky {
  background: color-mix(in srgb, var(--pinepost-sky) 28%, white);
  border-color: color-mix(in srgb, var(--pinepost-focus) 42%, white);
  color: #255b6a;
}

.pinepost-input,
.pinepost-textarea {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: inset 0 2px 0 rgba(75, 53, 25, 0.06);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  letter-spacing: 0;
  transition: border-color 160ms ease, box-shadow 160ms ease;
  width: 100%;
}

.pinepost-input::placeholder,
.pinepost-textarea::placeholder {
  color: color-mix(in srgb, var(--pinepost-muted) 72%, white);
}

.pinepost-input:hover,
.pinepost-textarea:hover {
  border-color: color-mix(in srgb, var(--pinepost-border-strong) 60%, var(--pinepost-border));
}

.pinepost-input--sm {
  font-size: 0.88rem;
  min-height: 34px;
  padding: 0 10px;
}

.pinepost-input--md {
  font-size: 0.95rem;
  min-height: 42px;
  padding: 0 13px;
}

.pinepost-input--lg {
  font-size: 1.03rem;
  min-height: 50px;
  padding: 0 15px;
}

.pinepost-textarea {
  font-size: 0.95rem;
  line-height: 1.45;
  min-height: 108px;
  padding: 12px 13px;
  resize: vertical;
}

.pinepost-select {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: var(--pinepost-ink);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 0.95rem;
  font-weight: 800;
  gap: 12px;
  justify-content: space-between;
  min-height: 42px;
  min-width: 190px;
  padding: 0 12px;
}

.pinepost-select:hover {
  border-color: color-mix(in srgb, var(--pinepost-border-strong) 60%, var(--pinepost-border));
}

.pinepost-select:focus-visible,
.pinepost-radio__item:focus-visible,
.pinepost-slider__thumb:focus-visible {
  outline: 3px solid var(--pinepost-ring);
  outline-offset: 3px;
}

.pinepost-select__icon {
  color: var(--pinepost-muted);
  font-size: 0.85rem;
  line-height: 1;
}

.pinepost-select__content {
  animation: pinepost-fade-in 130ms ease;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 var(--pinepost-border), 0 18px 34px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  min-width: var(--radix-select-trigger-width);
  overflow: hidden;
  z-index: 80;
}

.pinepost-select__viewport {
  display: grid;
  gap: 4px;
  padding: 6px;
}

.pinepost-select__state,
.pinepost-virtual-select__state,
.pinepost-virtual-table__state {
  color: var(--pinepost-muted);
  font-size: 0.9rem;
  font-weight: 850;
  line-height: 1.4;
  padding: 12px;
}

.pinepost-select__item {
  align-items: center;
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  display: grid;
  font-size: 0.92rem;
  font-weight: 800;
  gap: 10px;
  grid-template-columns: 1fr 16px;
  min-height: 34px;
  outline: none;
  padding: 7px 9px;
}

.pinepost-select__item[data-highlighted],
.pinepost-select__item[data-active="true"] {
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
}

.pinepost-select__item[data-disabled] {
  color: color-mix(in srgb, var(--pinepost-muted) 58%, white);
  cursor: not-allowed;
}

.pinepost-select__indicator {
  border-bottom: 2px solid var(--pinepost-leaf-dark);
  border-right: 2px solid var(--pinepost-leaf-dark);
  height: 10px;
  transform: rotate(45deg);
  width: 5px;
}

.pinepost-radio-group {
  display: grid;
  gap: 10px;
}

.pinepost-radio {
  align-items: flex-start;
  color: var(--pinepost-ink);
  cursor: pointer;
  display: inline-flex;
  gap: 10px;
}

.pinepost-radio[data-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.58;
}

.pinepost-radio__item {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: 999px;
  box-shadow: 0 2px 0 var(--pinepost-border);
  flex: 0 0 auto;
  height: 22px;
  margin-top: 1px;
  width: 22px;
}

.pinepost-radio__item[data-state="checked"] {
  background: color-mix(in srgb, var(--pinepost-leaf) 22%, var(--pinepost-paper-raised));
}

.pinepost-radio__indicator {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.pinepost-radio__indicator::before {
  background: var(--pinepost-leaf-dark);
  border-radius: 999px;
  content: "";
  height: 10px;
  width: 10px;
}

.pinepost-slider {
  align-items: center;
  display: flex;
  min-height: 28px;
  min-width: 180px;
  position: relative;
  touch-action: none;
  user-select: none;
}

.pinepost-slider__track {
  background: color-mix(in srgb, var(--pinepost-border) 52%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border-strong);
  border-radius: 999px;
  box-shadow: inset 0 2px 0 rgba(55, 37, 18, 0.12);
  flex: 1;
  height: 12px;
  overflow: hidden;
  position: relative;
}

.pinepost-slider__range {
  background: linear-gradient(90deg, var(--pinepost-leaf), color-mix(in srgb, var(--pinepost-sky) 70%, var(--pinepost-leaf)));
  height: 100%;
  position: absolute;
}

.pinepost-slider__thumb {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: 999px;
  box-shadow: 0 3px 0 var(--pinepost-border), 0 8px 16px var(--pinepost-shadow);
  display: block;
  height: 24px;
  width: 24px;
}

.pinepost-spinner {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  vertical-align: middle;
}

.pinepost-spinner--sm {
  height: 18px;
  width: 18px;
}

.pinepost-spinner--md {
  height: 24px;
  width: 24px;
}

.pinepost-spinner--lg {
  height: 32px;
  width: 32px;
}

.pinepost-spinner__mark {
  animation: pinepost-spin 760ms linear infinite;
  border: 3px solid color-mix(in srgb, var(--pinepost-border) 65%, white);
  border-radius: 999px;
  border-top-color: var(--pinepost-leaf-dark);
  display: block;
  height: 100%;
  width: 100%;
}

.pinepost-choice {
  align-items: flex-start;
  color: var(--pinepost-ink);
  display: flex;
  gap: 12px;
}

.pinepost-choice__text {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.pinepost-choice__label {
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
}

.pinepost-choice__description {
  color: var(--pinepost-muted);
  font-size: 0.86rem;
  line-height: 1.35;
}

.pinepost-checkbox {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-xs);
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: #fffdf6;
  cursor: pointer;
  display: inline-flex;
  height: 24px;
  justify-content: center;
  margin-top: 1px;
  min-width: 24px;
  width: 24px;
}

.pinepost-checkbox[data-state="checked"] {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
}

.pinepost-checkbox__indicator svg {
  display: block;
  height: 16px;
  width: 16px;
}

.pinepost-checkbox__indicator path {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.8;
}

.pinepost-switch {
  background: color-mix(in srgb, var(--pinepost-muted) 32%, white);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: 999px;
  box-shadow: inset 0 2px 0 rgba(55, 37, 18, 0.12), 0 2px 0 var(--pinepost-border);
  cursor: pointer;
  height: 28px;
  min-width: 50px;
  padding: 0;
  position: relative;
  width: 50px;
}

.pinepost-switch[data-state="checked"] {
  background: var(--pinepost-leaf);
}

.pinepost-switch__thumb {
  background:
    radial-gradient(circle at 34% 34%, rgba(255, 255, 255, 0.72) 0 18%, transparent 19%),
    var(--pinepost-paper-raised);
  border: 1px solid color-mix(in srgb, var(--pinepost-border-strong) 38%, white);
  border-radius: 999px;
  box-shadow: 0 2px 4px var(--pinepost-shadow);
  display: block;
  height: 20px;
  transform: translateX(3px);
  transition: transform 160ms ease;
  width: 20px;
}

.pinepost-switch[data-state="checked"] .pinepost-switch__thumb {
  transform: translateX(23px);
}

.pinepost-tabs__list {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 58%, var(--pinepost-paper));
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  display: inline-flex;
  gap: 4px;
  padding: 4px;
}

.pinepost-tabs__trigger {
  background: transparent;
  border: 0;
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-muted);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-size: 0.9rem;
  font-weight: 800;
  min-height: 34px;
  padding: 0 12px;
  transition: background-color 160ms ease, color 160ms ease, transform 160ms ease;
  white-space: nowrap;
}

.pinepost-tabs__trigger:hover {
  color: var(--pinepost-ink);
}

.pinepost-tabs__trigger[data-state="active"] {
  background: var(--pinepost-paper-raised);
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: var(--pinepost-ink);
}

.pinepost-tabs__content {
  margin-top: 14px;
}

.pinepost-dialog__overlay {
  animation: pinepost-fade-in 150ms ease;
  background:
    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.07) 0 8px, transparent 8px 16px),
    rgba(32, 39, 30, 0.45);
  inset: 0;
  position: fixed;
  z-index: 40;
}

.pinepost-dialog__content {
  animation: pinepost-pop-in 180ms ease;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.36), transparent 34%),
    var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 6px 0 var(--pinepost-border), 0 26px 60px rgba(34, 24, 14, 0.3);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  left: 50%;
  max-height: min(82vh, 620px);
  max-width: min(92vw, 520px);
  overflow: auto;
  padding: 22px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 41;
}

.pinepost-dialog__header {
  display: grid;
  gap: 6px;
  margin-bottom: 18px;
}

.pinepost-dialog__title {
  font-size: 1.25rem;
  line-height: 1.2;
  margin: 0;
}

.pinepost-dialog__description {
  color: var(--pinepost-muted);
  font-size: 0.94rem;
  line-height: 1.45;
  margin: 0;
}

.pinepost-dialog__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 22px;
}

.pinepost-tooltip__content {
  animation: pinepost-fade-in 130ms ease;
  background: var(--pinepost-ink);
  border: 1px solid color-mix(in srgb, var(--pinepost-border) 28%, transparent);
  border-radius: var(--pinepost-radius-sm);
  box-shadow: 0 10px 24px var(--pinepost-shadow);
  color: var(--pinepost-paper-raised);
  font-family: var(--pinepost-font);
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1.25;
  max-width: 240px;
  padding: 9px 11px;
}

.pinepost-toast__viewport {
  bottom: 18px;
  display: grid;
  gap: 12px;
  list-style: none;
  margin: 0;
  max-width: min(420px, calc(100vw - 32px));
  padding: 0;
  position: fixed;
  right: 18px;
  width: 100%;
  z-index: 50;
}

.pinepost-toast {
  animation: pinepost-slide-in 180ms ease;
  background:
    linear-gradient(90deg, var(--pinepost-stamp) 0 7px, transparent 7px),
    var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 var(--pinepost-border), 0 18px 34px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  display: grid;
  font-family: var(--pinepost-font);
  gap: 5px;
  padding: 14px 42px 14px 18px;
  position: relative;
}

.pinepost-toast__title {
  font-size: 0.96rem;
  font-weight: 900;
  line-height: 1.25;
  margin: 0;
}

.pinepost-toast__description {
  color: var(--pinepost-muted);
  font-size: 0.88rem;
  line-height: 1.35;
  margin: 0;
}

.pinepost-toast__action {
  background: color-mix(in srgb, var(--pinepost-leaf) 18%, var(--pinepost-paper-raised));
  border: 1px solid color-mix(in srgb, var(--pinepost-leaf-dark) 48%, white);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-leaf-dark);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 800;
  justify-self: start;
  margin-top: 5px;
  min-height: 30px;
  padding: 0 10px;
}

.pinepost-toast__close {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: var(--pinepost-radius-xs);
  color: var(--pinepost-muted);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 1.05rem;
  height: 28px;
  justify-content: center;
  line-height: 1;
  position: absolute;
  right: 9px;
  top: 9px;
  width: 28px;
}

.pinepost-text {
  color: var(--pinepost-ink);
  line-height: 1.45;
}

.pinepost-text--sm {
  font-size: 0.86rem;
}

.pinepost-text--md {
  font-size: 0.96rem;
}

.pinepost-text--lg {
  font-size: 1.08rem;
}

.pinepost-text--muted {
  color: var(--pinepost-muted);
}

.pinepost-text--success {
  color: var(--pinepost-leaf-dark);
}

.pinepost-text--warning {
  color: #8a5f13;
}

.pinepost-text--danger {
  color: var(--pinepost-stamp-dark);
}

.pinepost-link {
  border-radius: var(--pinepost-radius-xs);
  color: var(--pinepost-leaf-dark);
  font-weight: 900;
  text-decoration: underline;
  text-decoration-color: color-mix(in srgb, var(--pinepost-leaf) 44%, transparent);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

.pinepost-link:hover {
  color: var(--pinepost-stamp-dark);
  text-decoration-color: currentColor;
}

.pinepost-space {
  display: flex;
  gap: var(--pinepost-space-gap, 12px);
}

.pinepost-space[data-wrap="true"] {
  flex-wrap: wrap;
}

.pinepost-space--horizontal {
  align-items: center;
  flex-direction: row;
}

.pinepost-space--vertical {
  align-items: stretch;
  flex-direction: column;
}

.pinepost-divider {
  background: color-mix(in srgb, var(--pinepost-border) 76%, transparent);
  border: 0;
  flex: none;
}

.pinepost-divider--horizontal {
  height: 2px;
  min-width: 100%;
}

.pinepost-divider--vertical {
  align-self: stretch;
  min-height: 1.4em;
  width: 2px;
}

.pinepost-alert {
  align-items: flex-start;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border), 0 12px 24px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  display: flex;
  gap: 12px;
  padding: 14px;
}

.pinepost-alert__stamp {
  border-radius: var(--pinepost-radius-sm);
  display: inline-block;
  height: 28px;
  margin-top: 1px;
  min-width: 28px;
  outline: 1px dashed rgba(255, 255, 255, 0.62);
  outline-offset: -5px;
  width: 28px;
}

.pinepost-alert--info .pinepost-alert__stamp {
  background: var(--pinepost-sky);
}

.pinepost-alert--success .pinepost-alert__stamp {
  background: var(--pinepost-leaf);
}

.pinepost-alert--warning .pinepost-alert__stamp {
  background: var(--pinepost-parcel);
}

.pinepost-alert--danger .pinepost-alert__stamp {
  background: var(--pinepost-stamp);
}

.pinepost-alert__body,
.pinepost-empty,
.pinepost-result,
.pinepost-statistic {
  display: grid;
  gap: 5px;
}

.pinepost-alert__title {
  line-height: 1.25;
}

.pinepost-alert__description,
.pinepost-empty__description,
.pinepost-result__description,
.pinepost-statistic__label,
.pinepost-timeline__item span,
.pinepost-descriptions dd {
  color: var(--pinepost-muted);
  line-height: 1.4;
}

.pinepost-tag {
  align-items: center;
  border: 1px solid transparent;
  border-radius: var(--pinepost-radius-sm);
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 0.76rem;
  font-weight: 900;
  min-height: 24px;
  padding: 0 9px;
  white-space: nowrap;
}

.pinepost-tag--leaf {
  background: color-mix(in srgb, var(--pinepost-leaf) 20%, white);
  border-color: color-mix(in srgb, var(--pinepost-leaf-dark) 45%, white);
  color: var(--pinepost-leaf-dark);
}

.pinepost-tag--stamp {
  background: color-mix(in srgb, var(--pinepost-stamp) 18%, white);
  border-color: color-mix(in srgb, var(--pinepost-stamp-dark) 50%, white);
  color: var(--pinepost-stamp-dark);
}

.pinepost-tag--parcel {
  background: color-mix(in srgb, var(--pinepost-parcel) 22%, white);
  border-color: color-mix(in srgb, var(--pinepost-border-strong) 48%, white);
  color: #624220;
}

.pinepost-tag--sky {
  background: color-mix(in srgb, var(--pinepost-sky) 26%, white);
  border-color: color-mix(in srgb, var(--pinepost-focus) 38%, white);
  color: #285c6a;
}

.pinepost-avatar {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 64%, var(--pinepost-paper-raised));
  border: 2px solid var(--pinepost-border-strong);
  border-radius: 999px;
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: var(--pinepost-leaf-dark);
  display: inline-flex;
  font-weight: 900;
  justify-content: center;
  overflow: hidden;
}

.pinepost-avatar--sm {
  height: 32px;
  width: 32px;
}

.pinepost-avatar--md {
  height: 42px;
  width: 42px;
}

.pinepost-avatar--lg {
  height: 56px;
  width: 56px;
}

.pinepost-avatar__image {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.pinepost-avatar__fallback {
  font-size: 0.88rem;
}

.pinepost-empty,
.pinepost-result {
  align-items: center;
  border: 2px dashed var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  justify-items: center;
  padding: 28px 18px;
  text-align: center;
}

.pinepost-empty__mark,
.pinepost-result__seal {
  background:
    linear-gradient(45deg, transparent 46%, rgba(90, 62, 31, 0.14) 46% 54%, transparent 54%),
    var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  height: 46px;
  width: 58px;
}

.pinepost-result__seal {
  border-radius: 999px;
  height: 48px;
  width: 48px;
}

.pinepost-result--success .pinepost-result__seal {
  background: var(--pinepost-leaf);
}

.pinepost-result--warning .pinepost-result__seal {
  background: var(--pinepost-parcel);
}

.pinepost-result--danger .pinepost-result__seal {
  background: var(--pinepost-stamp);
}

.pinepost-progress {
  display: grid;
  gap: 6px;
}

.pinepost-progress__track {
  background: color-mix(in srgb, var(--pinepost-border) 42%, white);
  border: 2px solid var(--pinepost-border);
  border-radius: 999px;
  display: block;
  height: 18px;
  overflow: hidden;
}

.pinepost-progress__bar {
  background:
    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0 8px, transparent 8px 16px),
    var(--pinepost-leaf);
  display: block;
  height: 100%;
  transition: width 180ms ease;
}

.pinepost-progress__label {
  color: var(--pinepost-muted);
  font-size: 0.84rem;
  font-weight: 800;
}

.pinepost-skeleton {
  display: grid;
  gap: 9px;
}

.pinepost-skeleton__line {
  animation: pinepost-skeleton-pulse 1.4s ease-in-out infinite;
  background: linear-gradient(90deg, var(--pinepost-border), color-mix(in srgb, var(--pinepost-paper-raised) 86%, white), var(--pinepost-border));
  background-size: 220% 100%;
  border-radius: var(--pinepost-radius-sm);
  display: block;
  height: 15px;
}

.pinepost-skeleton__line:nth-child(2n) {
  width: 78%;
}

.pinepost-descriptions {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  overflow: hidden;
}

.pinepost-descriptions__title {
  display: block;
  padding: 12px 14px 0;
}

.pinepost-descriptions__list {
  display: grid;
  grid-template-columns: minmax(90px, 0.35fr) minmax(0, 1fr);
  margin: 0;
  padding: 12px 14px;
}

.pinepost-descriptions dt,
.pinepost-descriptions dd {
  border-top: 1px dashed color-mix(in srgb, var(--pinepost-border) 80%, transparent);
  margin: 0;
  padding: 9px 0;
}

.pinepost-descriptions dt {
  font-weight: 900;
}

.pinepost-statistic {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  padding: 14px;
}

.pinepost-statistic__value {
  align-items: baseline;
  display: flex;
  gap: 4px;
  font-size: 2rem;
  line-height: 1;
}

.pinepost-statistic__value small {
  color: var(--pinepost-muted);
  font-size: 0.95rem;
}

.pinepost-timeline {
  display: grid;
  gap: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pinepost-timeline__item {
  display: grid;
  gap: 3px 12px;
  grid-template-columns: 18px minmax(0, 1fr);
}

.pinepost-timeline__item::before {
  background: var(--pinepost-border);
  content: "";
  grid-column: 1;
  grid-row: 2 / span 2;
  justify-self: center;
  width: 2px;
}

.pinepost-timeline__dot {
  background: var(--pinepost-stamp);
  border: 2px solid var(--pinepost-paper-raised);
  border-radius: 999px;
  box-shadow: 0 0 0 2px var(--pinepost-border);
  grid-column: 1;
  grid-row: 1;
  height: 12px;
  margin-top: 3px;
  width: 12px;
}

.pinepost-timeline__item strong,
.pinepost-timeline__item span {
  grid-column: 2;
}

.pinepost-watermark {
  position: relative;
}

.pinepost-watermark::after {
  color: color-mix(in srgb, var(--pinepost-border-strong) 18%, transparent);
  content: var(--pinepost-watermark-content);
  font-size: 1.6rem;
  font-weight: 900;
  inset: 0;
  letter-spacing: 0;
  pointer-events: none;
  position: absolute;
  transform: rotate(-16deg);
  transform-origin: center;
}

.pinepost-breadcrumb__list {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pinepost-breadcrumb__item,
.pinepost-breadcrumb__separator {
  align-items: center;
  display: inline-flex;
}

.pinepost-breadcrumb__link {
  color: var(--pinepost-leaf-dark);
  font-weight: 900;
  text-decoration: none;
}

.pinepost-breadcrumb__page,
.pinepost-breadcrumb__separator {
  color: var(--pinepost-muted);
  font-weight: 800;
}

.pinepost-menu,
.pinepost-segmented,
.pinepost-pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pinepost-menu--vertical {
  align-items: stretch;
  flex-direction: column;
}

.pinepost-menu__item,
.pinepost-segmented button,
.pinepost-pagination button {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 36px;
  padding: 0 12px;
}

.pinepost-menu__item[data-state="active"],
.pinepost-segmented button[data-state="active"],
.pinepost-pagination button[data-state="active"] {
  background: color-mix(in srgb, var(--pinepost-moss) 72%, var(--pinepost-paper-raised));
  border-color: var(--pinepost-border-strong);
  box-shadow: 0 2px 0 var(--pinepost-border);
}

.pinepost-menu__item:disabled,
.pinepost-segmented button:disabled,
.pinepost-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.pinepost-steps {
  display: flex;
  gap: 16px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pinepost-steps--vertical {
  flex-direction: column;
}

.pinepost-steps__item {
  align-items: flex-start;
  display: flex;
  flex: 1;
  gap: 10px;
  min-width: 0;
}

.pinepost-steps__marker {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: 999px;
  color: var(--pinepost-muted);
  display: inline-flex;
  font-weight: 900;
  height: 30px;
  justify-content: center;
  min-width: 30px;
}

.pinepost-steps__marker[data-state="done"],
.pinepost-steps__marker[data-state="active"] {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-steps__body {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.pinepost-steps__body strong[data-state="active"] {
  color: var(--pinepost-stamp-dark);
}

.pinepost-steps__body span {
  color: var(--pinepost-muted);
  font-size: 0.86rem;
  line-height: 1.35;
}

.pinepost-dropdown__content,
.pinepost-popover__content {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 var(--pinepost-border), 0 16px 32px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  min-width: 190px;
  padding: 8px;
  z-index: 60;
}

.pinepost-popover__content {
  line-height: 1.4;
  max-width: 280px;
  padding: 14px;
}

.pinepost-dropdown__item {
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  font-size: 0.92rem;
  font-weight: 800;
  outline: none;
  padding: 9px 10px;
}

.pinepost-dropdown__item[data-highlighted] {
  background: var(--pinepost-moss);
}

.pinepost-collapse__header {
  margin: 0;
}

.pinepost-collapse__trigger {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 42px;
  padding: 0 14px;
  text-align: left;
  width: 100%;
}

.pinepost-collapse__content {
  color: var(--pinepost-muted);
  line-height: 1.45;
  overflow: hidden;
  padding: 12px 14px;
}

.pinepost-popconfirm__overlay,
.pinepost-drawer__overlay {
  background: rgba(32, 39, 30, 0.42);
  inset: 0;
  position: fixed;
  z-index: 70;
}

.pinepost-popconfirm__content {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 5px 0 var(--pinepost-border), 0 24px 56px rgba(34, 24, 14, 0.26);
  color: var(--pinepost-ink);
  display: grid;
  font-family: var(--pinepost-font);
  gap: 10px;
  left: 50%;
  max-width: min(92vw, 360px);
  padding: 18px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 71;
}

.pinepost-popconfirm__title {
  font-size: 1.05rem;
  margin: 0;
}

.pinepost-popconfirm__description {
  color: var(--pinepost-muted);
  line-height: 1.42;
  margin: 0;
}

.pinepost-popconfirm__cancel,
.pinepost-popconfirm__action {
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 34px;
  padding: 0 12px;
}

.pinepost-popconfirm__cancel {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  color: var(--pinepost-ink);
}

.pinepost-popconfirm__action {
  background: var(--pinepost-stamp);
  border: 2px solid var(--pinepost-stamp-dark);
  color: #fffdf6;
}

.pinepost-drawer__content {
  background: var(--pinepost-paper-raised);
  border: 0 solid var(--pinepost-border-strong);
  bottom: 0;
  box-shadow: 0 0 46px rgba(34, 24, 14, 0.26);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  max-width: min(92vw, 420px);
  padding: 20px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 71;
}

.pinepost-drawer__content[data-side="right"] {
  border-left-width: 2px;
  right: 0;
}

.pinepost-drawer__content[data-side="left"] {
  border-right-width: 2px;
  left: 0;
}

.pinepost-drawer__header {
  display: grid;
  gap: 6px;
}

.pinepost-drawer__title {
  font-size: 1.22rem;
  line-height: 1.2;
  margin: 0;
}

.pinepost-drawer__description {
  color: var(--pinepost-muted);
  line-height: 1.45;
  margin: 0;
}

.pinepost-drawer__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 22px;
}

.pinepost-form {
  display: grid;
  gap: 16px;
}

.pinepost-form--horizontal .pinepost-form-field {
  align-items: start;
  grid-template-columns: minmax(120px, 0.28fr) minmax(0, 1fr);
}

.pinepost-form--inline {
  align-items: end;
  display: flex;
  flex-wrap: wrap;
}

.pinepost-form-field {
  display: grid;
  gap: 7px;
}

.pinepost-form-field__label {
  color: var(--pinepost-ink);
  font-size: 0.9rem;
  font-weight: 900;
  line-height: 1.25;
}

.pinepost-form-field__label span {
  color: var(--pinepost-stamp-dark);
  margin-left: 4px;
}

.pinepost-form-field__control {
  min-width: 0;
}

.pinepost-form-field__description,
.pinepost-form-field__error {
  font-size: 0.84rem;
  line-height: 1.35;
  margin: 0;
}

.pinepost-form-field__description {
  color: var(--pinepost-muted);
}

.pinepost-form-field__error {
  color: var(--pinepost-stamp-dark);
  font-weight: 800;
}

.pinepost-form-field[data-validating="true"] .pinepost-form-field__description {
  color: var(--pinepost-leaf-dark);
  font-weight: 800;
}

.pinepost-form-field[data-invalid="true"] .pinepost-input,
.pinepost-form-field[data-invalid="true"] .pinepost-textarea {
  border-color: var(--pinepost-stamp);
}

.pinepost-form__status,
.pinepost-form__submit-error {
  border-radius: var(--pinepost-radius-sm);
  font-size: 0.86rem;
  font-weight: 900;
  line-height: 1.4;
  margin: 0;
  padding: 9px 11px;
}

.pinepost-form__status {
  background: color-mix(in srgb, var(--pinepost-moss) 58%, var(--pinepost-paper-raised));
  color: var(--pinepost-leaf-dark);
}

.pinepost-form__submit-error {
  background: color-mix(in srgb, var(--pinepost-stamp) 16%, var(--pinepost-paper-raised));
  color: var(--pinepost-stamp-dark);
}

.pinepost-input-number {
  align-items: stretch;
  display: inline-grid;
  grid-template-columns: 38px minmax(72px, 1fr) 38px;
  max-width: 180px;
}

.pinepost-input-number input,
.pinepost-input-number button {
  font-family: var(--pinepost-font);
}

.pinepost-input-number input {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-left: 0;
  border-right: 0;
  color: var(--pinepost-ink);
  font-weight: 800;
  min-width: 0;
  text-align: center;
}

.pinepost-input-number button {
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
  border: 2px solid var(--pinepost-border);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-weight: 900;
}

.pinepost-input-number button:first-child {
  border-radius: var(--pinepost-radius-md) 0 0 var(--pinepost-radius-md);
}

.pinepost-input-number button:last-child {
  border-radius: 0 var(--pinepost-radius-md) var(--pinepost-radius-md) 0;
}

.pinepost-input-number--sm input,
.pinepost-input-number--sm button {
  min-height: 34px;
}

.pinepost-input-number--md input,
.pinepost-input-number--md button {
  min-height: 42px;
}

.pinepost-input-number--lg input,
.pinepost-input-number--lg button {
  min-height: 50px;
}

.pinepost-rate {
  align-items: center;
  display: inline-flex;
  gap: 7px;
}

.pinepost-rate__item {
  background: transparent;
  border: 0;
  cursor: pointer;
  height: 30px;
  padding: 0;
  width: 30px;
}

.pinepost-rate__item span {
  background: color-mix(in srgb, var(--pinepost-border) 64%, white);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-sm);
  display: block;
  height: 24px;
  transform: rotate(45deg);
  transition: background-color 150ms ease, transform 150ms ease;
  width: 24px;
}

.pinepost-rate__item[data-active="true"] span {
  background: var(--pinepost-parcel);
  transform: rotate(45deg) scale(1.06);
}

.pinepost-upload {
  display: grid;
  gap: 8px;
}

.pinepost-upload input[type="file"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.pinepost-upload__dropzone {
  align-items: center;
  background:
    repeating-linear-gradient(135deg, transparent 0 12px, rgba(255, 255, 255, 0.28) 12px 14px),
    var(--pinepost-paper-raised);
  border: 2px dashed var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  cursor: pointer;
  display: grid;
  gap: 7px;
  justify-items: center;
  min-height: 126px;
  padding: 18px;
  text-align: center;
}

.pinepost-upload[data-drag="true"] .pinepost-upload__dropzone {
  background:
    repeating-linear-gradient(0deg, rgba(140, 113, 71, 0.06) 0 1px, transparent 1px 22px),
    var(--pinepost-paper-raised);
}

.pinepost-upload[data-drag="true"] .pinepost-upload__dropzone:hover {
  border-color: var(--pinepost-leaf-dark);
}

.pinepost-upload__dropzone span {
  color: var(--pinepost-muted);
  line-height: 1.4;
}

.pinepost-upload__icon {
  background:
    linear-gradient(90deg, transparent 46%, rgba(88, 58, 26, 0.18) 46% 54%, transparent 54%),
    var(--pinepost-parcel);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  height: 38px;
  width: 52px;
}

.pinepost-color-picker {
  align-items: center;
  display: inline-flex;
  gap: 10px;
  font-weight: 900;
}

.pinepost-color-picker input {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  height: 38px;
  padding: 3px;
  width: 54px;
}

.pinepost-native-picker {
  max-width: 240px;
}

.pinepost-container {
  display: flex;
  min-width: 0;
}

.pinepost-container--vertical {
  flex-direction: column;
}

.pinepost-container--horizontal {
  align-items: stretch;
  flex-direction: row;
}

.pinepost-layout-header,
.pinepost-layout-aside,
.pinepost-layout-main,
.pinepost-layout-footer {
  border: 2px solid var(--pinepost-border);
  color: var(--pinepost-ink);
  font-weight: 900;
  padding: 14px;
}

.pinepost-layout-header,
.pinepost-layout-footer {
  background: color-mix(in srgb, var(--pinepost-moss) 54%, var(--pinepost-paper-raised));
}

.pinepost-layout-aside {
  background: color-mix(in srgb, var(--pinepost-sky) 26%, var(--pinepost-paper-raised));
  min-width: 120px;
}

.pinepost-layout-main {
  background: var(--pinepost-paper-raised);
  flex: 1;
}

.pinepost-row {
  display: grid;
  gap: var(--pinepost-row-gap, 12px);
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.pinepost-col {
  grid-column: span var(--pinepost-col-span, 12);
  min-width: 0;
}

.pinepost-scrollbar {
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  max-height: var(--pinepost-scrollbar-max-height, 220px);
  overflow: auto;
  padding: 12px;
  scrollbar-color: var(--pinepost-border-strong) var(--pinepost-paper-raised);
}

.pinepost-splitter {
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, calc(var(--pinepost-splitter-ratio, 0.5) * 100%)) minmax(0, 1fr);
}

.pinepost-splitter > * {
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  min-width: 0;
  padding: 14px;
}

.pinepost-table-wrap {
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  overflow: auto;
}

.pinepost-table__filterbar,
.pinepost-table__viewbar {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 44%, var(--pinepost-paper-raised));
  border-bottom: 1px dashed var(--pinepost-border);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 12px;
}

.pinepost-table__filterbar {
  background: color-mix(in srgb, var(--pinepost-sky) 16%, var(--pinepost-paper-raised));
}

.pinepost-table__filterbar span,
.pinepost-table__viewbar span {
  color: var(--pinepost-muted);
  font-size: 0.78rem;
  font-weight: 900;
}

.pinepost-table__filter-tag {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  display: inline-flex;
  gap: 6px;
  min-height: 28px;
  padding: 0 8px;
}

.pinepost-table__filter-tag button,
.pinepost-table__filter-clear,
.pinepost-table__viewbar button {
  background: var(--pinepost-paper-raised);
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 28px;
  padding: 0 10px;
}

.pinepost-table__filter-tag button {
  border-radius: 999px;
  height: 20px;
  min-height: 20px;
  padding: 0;
  width: 20px;
}

.pinepost-table__viewbar button[aria-pressed="true"] {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-table-settings {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  display: grid;
  gap: 14px;
  max-width: min(100%, 560px);
  padding: 14px;
}

.pinepost-table-settings__header strong,
.pinepost-table-settings__density > span,
.pinepost-table-settings__columns > span {
  color: var(--pinepost-leaf-dark);
  font-weight: 900;
}

.pinepost-table-settings__density {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pinepost-table-settings__density button,
.pinepost-table-settings__row button {
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 30px;
  padding: 0 10px;
}

.pinepost-table-settings__density button[aria-pressed="true"] {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-table-settings__row {
  align-items: center;
  border-top: 1px dashed color-mix(in srgb, var(--pinepost-border) 76%, transparent);
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) auto auto;
  padding: 9px 0;
}

.pinepost-table-settings__row label {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  min-width: 0;
}

.pinepost-table-settings__row strong {
  min-width: 0;
}

.pinepost-table {
  background: var(--pinepost-paper-raised);
  border-collapse: collapse;
  min-width: 520px;
  width: 100%;
}

.pinepost-table th,
.pinepost-table td {
  border-bottom: 1px dashed color-mix(in srgb, var(--pinepost-border) 78%, transparent);
  padding: 12px 14px;
  text-align: left;
}

.pinepost-table-wrap[data-density="compact"] .pinepost-table th,
.pinepost-table-wrap[data-density="compact"] .pinepost-table td {
  padding: 8px 10px;
}

.pinepost-table-wrap[data-density="spacious"] .pinepost-table th,
.pinepost-table-wrap[data-density="spacious"] .pinepost-table td {
  padding: 16px 18px;
}

.pinepost-table th {
  background: color-mix(in srgb, var(--pinepost-moss) 52%, var(--pinepost-paper-raised));
  color: var(--pinepost-leaf-dark);
  font-size: 0.84rem;
  font-weight: 900;
}

.pinepost-table__header-content {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  min-width: 0;
}

.pinepost-table__resize-controls {
  display: inline-flex;
  gap: 3px;
}

.pinepost-table__resize-controls button {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-paper) 72%, var(--pinepost-moss));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-leaf-dark);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 0.78rem;
  font-weight: 900;
  height: 22px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 22px;
}

.pinepost-calendar {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  overflow: hidden;
  width: min(100%, 420px);
}

.pinepost-calendar__header {
  background: color-mix(in srgb, var(--pinepost-moss) 56%, var(--pinepost-paper-raised));
  border-bottom: 1px dashed var(--pinepost-border);
  font-weight: 900;
  padding: 12px 14px;
}

.pinepost-calendar__grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  padding: 10px;
}

.pinepost-calendar__weekday,
.pinepost-calendar__day {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

.pinepost-calendar__weekday {
  color: var(--pinepost-muted);
  font-size: 0.78rem;
  font-weight: 900;
}

.pinepost-calendar__day {
  border-radius: var(--pinepost-radius-sm);
  font-weight: 800;
}

.pinepost-calendar__day[aria-selected="true"] {
  background: var(--pinepost-leaf);
  color: #fffdf6;
}

.pinepost-calendar__day[data-empty="true"] {
  opacity: 0.28;
}

.pinepost-image {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  display: grid;
  margin: 0;
  max-width: 360px;
  overflow: hidden;
}

.pinepost-image img {
  aspect-ratio: 16 / 9;
  display: block;
  width: 100%;
}

.pinepost-image img[data-fit="cover"] {
  object-fit: cover;
}

.pinepost-image img[data-fit="contain"] {
  object-fit: contain;
}

.pinepost-image figcaption {
  color: var(--pinepost-muted);
  font-size: 0.86rem;
  line-height: 1.35;
  padding: 10px 12px;
}

.pinepost-carousel {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  display: grid;
  max-width: 480px;
  overflow: hidden;
}

.pinepost-carousel__stage {
  align-items: center;
  background:
    repeating-linear-gradient(0deg, rgba(140, 113, 71, 0.06) 0 1px, transparent 1px 26px),
    color-mix(in srgb, var(--pinepost-moss) 22%, var(--pinepost-paper-raised));
  display: grid;
  min-height: 180px;
  padding: 24px;
}

.pinepost-carousel__controls {
  align-items: center;
  border-top: 1px dashed var(--pinepost-border);
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 10px;
}

.pinepost-carousel__controls button {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 34px;
  padding: 0 10px;
}

.pinepost-carousel__controls button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.pinepost-tree,
.pinepost-tree__children {
  display: grid;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pinepost-tree__children {
  border-left: 2px dashed var(--pinepost-border);
  margin-left: 10px;
  padding-left: 12px;
}

.pinepost-tree__item button {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-weight: 900;
  gap: 8px;
  min-height: 34px;
  padding: 0 10px;
}

.pinepost-tree__item button span {
  color: var(--pinepost-leaf-dark);
  display: inline-block;
  min-width: 12px;
}

.pinepost-page-header {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  display: grid;
  gap: 12px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 14px;
}

.pinepost-page-header__back {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 58%, var(--pinepost-paper-raised));
  border: 2px solid var(--pinepost-border);
  border-radius: 999px;
  color: var(--pinepost-ink);
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.pinepost-page-header h1 {
  font-size: 1.2rem;
  line-height: 1.2;
  margin: 0;
}

.pinepost-page-header p {
  color: var(--pinepost-muted);
  line-height: 1.4;
  margin: 4px 0 0;
}

.pinepost-page-header__extra {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pinepost-affix {
  position: sticky;
  top: var(--pinepost-affix-top, 0);
  z-index: 10;
}

.pinepost-backtop {
  background: var(--pinepost-leaf);
  border: 2px solid var(--pinepost-leaf-dark);
  border-radius: 999px;
  box-shadow: 0 3px 0 var(--pinepost-border-strong), 0 12px 24px var(--pinepost-shadow);
  color: #fffdf6;
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 42px;
  min-width: 42px;
  padding: 0 12px;
}

.pinepost-backtop[data-visible="false"] {
  opacity: 0;
  pointer-events: none;
}

.pinepost-anchor {
  align-items: flex-start;
  border-left: 3px solid var(--pinepost-border);
  display: grid;
  gap: 8px;
  padding-left: 12px;
}

.pinepost-anchor a {
  color: var(--pinepost-leaf-dark);
  font-weight: 900;
  text-decoration: none;
}

.pinepost-loading {
  align-items: center;
  display: grid;
  justify-items: center;
  min-height: 112px;
  position: relative;
}

.pinepost-loading[data-overlay="true"]::before {
  background: color-mix(in srgb, var(--pinepost-paper-raised) 78%, transparent);
  border-radius: inherit;
  content: "";
  inset: 0;
  position: absolute;
}

.pinepost-loading__indicator {
  align-items: center;
  color: var(--pinepost-muted);
  display: inline-flex;
  font-size: 0.9rem;
  font-weight: 900;
  gap: 9px;
  position: relative;
  z-index: 1;
}

.pinepost-message {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 11px 13px;
}

.pinepost-message__dot {
  border-radius: 999px;
  height: 12px;
  width: 12px;
}

.pinepost-message span:last-child {
  color: var(--pinepost-muted);
}

.pinepost-message--info .pinepost-message__dot,
.pinepost-notification--info .pinepost-notification__pin {
  background: var(--pinepost-sky);
}

.pinepost-message--success .pinepost-message__dot,
.pinepost-notification--success .pinepost-notification__pin {
  background: var(--pinepost-leaf);
}

.pinepost-message--warning .pinepost-message__dot,
.pinepost-notification--warning .pinepost-notification__pin {
  background: var(--pinepost-parcel);
}

.pinepost-message--danger .pinepost-message__dot,
.pinepost-notification--danger .pinepost-notification__pin {
  background: var(--pinepost-stamp);
}

.pinepost-notification {
  background:
    linear-gradient(90deg, color-mix(in srgb, var(--pinepost-moss) 42%, transparent), transparent 54%),
    var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 var(--pinepost-border), 0 18px 34px var(--pinepost-shadow);
  display: grid;
  gap: 7px;
  max-width: 380px;
  padding: 16px 16px 16px 46px;
  position: relative;
}

.pinepost-notification__pin {
  border-radius: 999px;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--pinepost-border) 70%, white);
  height: 16px;
  left: 17px;
  position: absolute;
  top: 18px;
  width: 16px;
}

.pinepost-notification p {
  color: var(--pinepost-muted);
  line-height: 1.45;
  margin: 0;
}

.pinepost-notification__action {
  margin-top: 4px;
}

.pinepost-message-stack,
.pinepost-notification-stack,
.pinepost-loading-stack {
  display: grid;
  gap: 10px;
  justify-items: start;
  margin: 0 0 12px;
}

.pinepost-notification-stack {
  justify-items: stretch;
  max-width: 420px;
}

.pinepost-message-box__overlay {
  background: rgba(32, 39, 30, 0.42);
  inset: 0;
  position: fixed;
  z-index: 80;
}

.pinepost-message-box {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 5px 0 var(--pinepost-border), 0 24px 56px rgba(34, 24, 14, 0.26);
  color: var(--pinepost-ink);
  display: grid;
  font-family: var(--pinepost-font);
  gap: 12px;
  left: 50%;
  max-width: min(92vw, 420px);
  padding: 20px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 81;
}

.pinepost-message-box__title {
  font-size: 1.12rem;
  margin: 0;
}

.pinepost-message-box__description {
  color: var(--pinepost-muted);
  line-height: 1.45;
  margin: 0;
}

.pinepost-message-box__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 8px;
}

.pinepost-picker-trigger {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: var(--pinepost-ink);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-size: 0.95rem;
  font-weight: 900;
  gap: 10px;
  justify-content: space-between;
  min-height: 42px;
  min-width: 220px;
  padding: 0 42px 0 12px;
}

.pinepost-picker-trigger [data-placeholder="true"] {
  color: color-mix(in srgb, var(--pinepost-muted) 72%, white);
}

.pinepost-picker-trigger__clear {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 60%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: 999px;
  color: var(--pinepost-muted);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-weight: 900;
  height: 22px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 10px;
  width: 22px;
}

.pinepost-cascader,
.pinepost-tree-select,
.pinepost-virtual-select,
.pinepost-mention {
  display: inline-grid;
  max-width: 100%;
  position: relative;
}

.pinepost-cascader__panel,
.pinepost-tree-select__panel,
.pinepost-virtual-select__panel,
.pinepost-mention__panel {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 4px 0 var(--pinepost-border), 0 18px 34px var(--pinepost-shadow);
  color: var(--pinepost-ink);
  margin-top: 8px;
  min-width: 260px;
  overflow: hidden;
  position: absolute;
  top: 100%;
  z-index: 65;
}

.pinepost-cascader__filter,
.pinepost-transfer__filter {
  background: var(--pinepost-paper-raised);
  border: 0;
  border-bottom: 1px dashed var(--pinepost-border);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  min-height: 38px;
  padding: 0 11px;
  width: 100%;
}

.pinepost-cascader__menus {
  display: flex;
  max-width: min(88vw, 620px);
  overflow: auto;
}

.pinepost-cascader__menu {
  border-right: 1px dashed var(--pinepost-border);
  display: grid;
  min-width: 160px;
  padding: 6px;
}

.pinepost-cascader__menu button,
.pinepost-cascader__matches button,
.pinepost-tree-select__node,
.pinepost-virtual-select__list button,
.pinepost-mention__panel button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  display: flex;
  font-family: var(--pinepost-font);
  font-weight: 900;
  gap: 8px;
  justify-content: space-between;
  min-height: 36px;
  padding: 0 10px;
  text-align: left;
  width: 100%;
}

.pinepost-cascader__menu button[data-active="true"],
.pinepost-cascader__matches button:hover,
.pinepost-tree-select__node:hover,
.pinepost-tree-select__node[data-selected="true"],
.pinepost-virtual-select__list button:hover,
.pinepost-virtual-select__list button[data-selected="true"],
.pinepost-mention__panel button:hover {
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
}

.pinepost-cascader__matches {
  display: grid;
  max-height: 260px;
  overflow: auto;
  padding: 6px;
}

.pinepost-transfer {
  align-items: stretch;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  width: min(100%, 760px);
}

.pinepost-transfer__list {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  display: grid;
  grid-template-rows: auto auto 1fr;
  min-height: 260px;
  min-width: 0;
  overflow: hidden;
}

.pinepost-transfer__list > strong {
  background: color-mix(in srgb, var(--pinepost-moss) 56%, var(--pinepost-paper-raised));
  border-bottom: 1px dashed var(--pinepost-border);
  padding: 11px 12px;
}

.pinepost-transfer__body {
  display: grid;
  gap: 4px;
  max-height: 260px;
  overflow: auto;
  padding: 8px;
}

.pinepost-transfer__item {
  align-items: flex-start;
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  display: flex;
  gap: 8px;
  padding: 8px;
}

.pinepost-transfer__item:hover {
  background: color-mix(in srgb, var(--pinepost-moss) 44%, var(--pinepost-paper-raised));
}

.pinepost-transfer__item small {
  color: var(--pinepost-muted);
  display: block;
  font-size: 0.78rem;
  line-height: 1.35;
  margin-top: 3px;
}

.pinepost-transfer__item[data-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.55;
}

.pinepost-transfer__actions {
  align-self: center;
  display: grid;
  gap: 8px;
}

.pinepost-transfer__actions button {
  background: var(--pinepost-leaf);
  border: 2px solid var(--pinepost-leaf-dark);
  border-radius: 999px;
  color: #fffdf6;
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-size: 1.1rem;
  font-weight: 900;
  height: 38px;
  width: 38px;
}

.pinepost-transfer__actions button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.pinepost-tree-select__panel,
.pinepost-virtual-select__panel {
  min-width: 280px;
}

.pinepost-tree-select__body {
  display: grid;
  max-height: 280px;
  overflow: auto;
  padding: 6px;
}

.pinepost-tree-select__node {
  justify-content: flex-start;
  padding-left: calc(10px + var(--pinepost-tree-level, 0) * 18px);
}

.pinepost-tree-select__node > span {
  color: var(--pinepost-leaf-dark);
  min-width: 12px;
}

.pinepost-virtual-select__list {
  overflow: auto;
}

.pinepost-virtual-select__state {
  min-height: 100%;
}

.pinepost-virtual-select__list button {
  height: var(--pinepost-item-height, 38px);
}

.pinepost-input-tag {
  align-items: center;
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: inset 0 2px 0 rgba(75, 53, 25, 0.06);
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  min-height: 42px;
  padding: 5px;
}

.pinepost-input-tag input {
  background: transparent;
  border: 0;
  color: var(--pinepost-ink);
  flex: 1 1 120px;
  font-family: var(--pinepost-font);
  min-height: 30px;
  outline: none;
}

.pinepost-input-tag__tag {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  display: inline-flex;
  font-size: 0.84rem;
  font-weight: 900;
  gap: 5px;
  min-height: 28px;
  padding: 0 7px;
}

.pinepost-input-tag__tag button,
.pinepost-input-tag__clear {
  background: transparent;
  border: 0;
  color: var(--pinepost-muted);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
}

.pinepost-input-otp {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pinepost-input-otp input {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 2px 0 var(--pinepost-border);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  font-size: 1.1rem;
  font-weight: 900;
  height: 42px;
  text-align: center;
  width: 42px;
}

.pinepost-mention {
  width: min(100%, 460px);
}

.pinepost-mention__panel {
  display: grid;
  margin-top: 4px;
  max-height: 220px;
  overflow: auto;
  padding: 6px;
}

.pinepost-mention__panel button {
  display: grid;
  justify-items: start;
}

.pinepost-mention__panel small {
  color: var(--pinepost-muted);
}

.pinepost-time-select {
  max-width: 220px;
}

.pinepost-virtual-table {
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  overflow: hidden;
}

.pinepost-virtual-table .pinepost-table {
  border: 0;
  min-width: 560px;
}

.pinepost-virtual-table__body {
  overflow: auto;
}

.pinepost-virtual-table__body tr {
  cursor: pointer;
  height: var(--pinepost-row-height, 44px);
}

.pinepost-virtual-table__state {
  text-align: center;
}

.pinepost-virtual-tree {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  overflow: hidden;
  width: min(100%, 420px);
}

.pinepost-virtual-tree__body {
  overflow: auto;
}

.pinepost-virtual-tree__row {
  align-items: center;
  background: transparent;
  border: 0;
  color: var(--pinepost-ink);
  cursor: pointer;
  display: flex;
  font-family: var(--pinepost-font);
  font-weight: 900;
  gap: 8px;
  height: var(--pinepost-tree-row-height, 38px);
  padding-left: calc(12px + var(--pinepost-tree-level, 0) * 18px);
  text-align: left;
  width: 100%;
}

.pinepost-virtual-tree__row:hover,
.pinepost-virtual-tree__row[data-selected="true"] {
  background: color-mix(in srgb, var(--pinepost-moss) 58%, var(--pinepost-paper-raised));
}

.pinepost-virtual-tree__row span {
  color: var(--pinepost-leaf-dark);
  min-width: 12px;
}

.pinepost-tour {
  inset: 0;
  pointer-events: none;
  position: fixed;
  z-index: 90;
}

.pinepost-tour__mask {
  background: rgba(32, 39, 30, 0.38);
  inset: 0;
  pointer-events: auto;
  position: absolute;
}

.pinepost-tour__card {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 5px 0 var(--pinepost-border), 0 24px 56px rgba(34, 24, 14, 0.26);
  color: var(--pinepost-ink);
  display: grid;
  gap: 9px;
  left: 50%;
  max-width: min(92vw, 380px);
  padding: 18px;
  pointer-events: auto;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.pinepost-tour__count {
  color: var(--pinepost-stamp-dark);
  font-size: 0.8rem;
  font-weight: 900;
}

.pinepost-tour__card strong {
  font-size: 1.08rem;
}

.pinepost-tour__card p {
  color: var(--pinepost-muted);
  line-height: 1.45;
  margin: 0;
}

.pinepost-tour__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 6px;
}

.pinepost-tour__actions button {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 34px;
  padding: 0 10px;
}

.pinepost-tour__actions button:not(:disabled):nth-child(2) {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-tour__actions button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.pinepost-icon {
  color: var(--pinepost-leaf-dark);
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: middle;
}

.pinepost-color-panel,
.pinepost-date-panel,
.pinepost-date-time-panel {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  display: grid;
  gap: 12px;
  max-width: min(100%, 420px);
  padding: 14px;
}

.pinepost-date-time-panel {
  max-width: min(100%, 680px);
}

.pinepost-date-time-panel > .pinepost-date-panel {
  box-shadow: none;
  max-width: 100%;
}

.pinepost-color-panel label {
  align-items: center;
  display: flex;
  font-weight: 900;
  gap: 12px;
}

.pinepost-color-panel input[type="color"] {
  background: transparent;
  border: 0;
  height: 36px;
  padding: 0;
  width: 56px;
}

.pinepost-color-panel__presets,
.pinepost-date-panel__shortcuts,
.pinepost-date-time-panel__shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pinepost-color-panel__swatch {
  background: var(--pinepost-swatch);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-sm);
  box-shadow: 0 2px 0 var(--pinepost-border);
  cursor: pointer;
  height: 34px;
  width: 34px;
}

.pinepost-color-panel__swatch[data-active="true"] {
  outline: 3px solid var(--pinepost-ring);
  outline-offset: 2px;
}

.pinepost-date-panel__header {
  align-items: center;
  border-bottom: 1px dashed var(--pinepost-border);
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.pinepost-date-panel__shortcuts button,
.pinepost-date-time-panel__shortcuts button,
.pinepost-time-range-panel__shortcuts button,
.pinepost-time-panel button,
.pinepost-table__sort {
  background: color-mix(in srgb, var(--pinepost-moss) 54%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-height: 30px;
  padding: 0 9px;
}

.pinepost-time-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 180px;
  overflow: auto;
  padding: 2px;
}

.pinepost-time-panel button[aria-pressed="true"] {
  background: var(--pinepost-leaf);
  border-color: var(--pinepost-leaf-dark);
  color: #fffdf6;
}

.pinepost-date-panel__grid {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.pinepost-date-panel__weekday,
.pinepost-date-panel__day {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: 36px;
}

.pinepost-date-panel__weekday {
  color: var(--pinepost-muted);
  font-size: 0.78rem;
  font-weight: 900;
}

.pinepost-date-panel__day {
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
}

.pinepost-date-panel__day[aria-pressed="true"] {
  background: var(--pinepost-leaf);
  color: #fffdf6;
}

.pinepost-date-panel__day[data-in-range="true"] {
  background: color-mix(in srgb, var(--pinepost-leaf) 24%, var(--pinepost-paper-raised));
  border-color: color-mix(in srgb, var(--pinepost-leaf-dark) 42%, transparent);
}

.pinepost-date-panel__day[data-empty] {
  opacity: 0.2;
}

.pinepost-time-range-panel {
  background: var(--pinepost-paper-raised);
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  box-shadow: 0 3px 0 var(--pinepost-border);
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: min(100%, 720px);
  padding: 14px;
}

.pinepost-time-range-panel__shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  grid-column: 1 / -1;
}

.pinepost-time-range-panel__column {
  border: 1px dashed var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  display: grid;
  gap: 10px;
  min-width: 0;
  padding: 10px;
}

.pinepost-time-range-panel__column > strong {
  color: var(--pinepost-leaf-dark);
  font-size: 0.84rem;
}

.pinepost-infinite-scroll {
  border: 2px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-md);
  max-height: 220px;
  overflow: auto;
  padding: 12px;
}

.pinepost-infinite-scroll__loading {
  color: var(--pinepost-muted);
  font-weight: 900;
  padding: 12px;
  text-align: center;
}

.pinepost-select-wrap {
  display: inline-grid;
  max-width: 100%;
  position: relative;
}

.pinepost-select__clear {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 60%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: 999px;
  color: var(--pinepost-muted);
  cursor: pointer;
  display: inline-flex;
  font-weight: 900;
  height: 22px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 34px;
  top: 10px;
  width: 22px;
}

.pinepost-select__content {
  left: 0;
  margin-top: 8px;
  position: absolute;
  top: 100%;
}

.pinepost-select__filter {
  background: var(--pinepost-paper-raised);
  border: 0;
  border-bottom: 1px dashed var(--pinepost-border);
  color: var(--pinepost-ink);
  font-family: var(--pinepost-font);
  min-height: 38px;
  padding: 0 11px;
  width: 100%;
}

.pinepost-select__group {
  display: grid;
  gap: 4px;
}

.pinepost-select__group > strong {
  color: var(--pinepost-muted);
  font-size: 0.76rem;
  padding: 6px 8px 2px;
}

.pinepost-select__item {
  background: transparent;
  border: 0;
  grid-template-columns: auto minmax(0, 1fr) 16px;
  text-align: left;
}

.pinepost-select__item input {
  pointer-events: none;
}

.pinepost-table__sort {
  background: transparent;
  border: 0;
  color: inherit;
  min-height: 24px;
  padding: 0;
}

.pinepost-table tr[data-selected="true"],
.pinepost-table tr[data-current="true"] {
  background: color-mix(in srgb, var(--pinepost-moss) 42%, transparent);
}

.pinepost-table th[data-group="true"] {
  text-align: center;
}

.pinepost-table th[data-fixed],
.pinepost-table td[data-fixed] {
  background: var(--pinepost-paper-raised);
  box-shadow: 1px 0 0 color-mix(in srgb, var(--pinepost-border) 70%, transparent);
}

.pinepost-table th[data-fixed] {
  background: color-mix(in srgb, var(--pinepost-moss) 52%, var(--pinepost-paper-raised));
  z-index: 4;
}

.pinepost-table__expand {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 62%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-leaf-dark);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--pinepost-font);
  font-weight: 900;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.pinepost-table__editor {
  background: var(--pinepost-paper);
  border: 2px solid var(--pinepost-border-strong);
  border-radius: var(--pinepost-radius-sm);
  color: var(--pinepost-ink);
  font: inherit;
  min-height: 32px;
  padding: 0 8px;
  width: min(100%, 220px);
}

.pinepost-table__expanded-row td {
  background: color-mix(in srgb, var(--pinepost-sky) 18%, var(--pinepost-paper-raised));
  color: var(--pinepost-muted);
}

.pinepost-table__summary-row td {
  background: color-mix(in srgb, var(--pinepost-moss) 44%, var(--pinepost-paper-raised));
  color: var(--pinepost-leaf-dark);
  font-weight: 900;
}

.pinepost-upload__list {
  display: grid;
  gap: 6px;
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
}

.pinepost-upload__list li {
  align-items: center;
  background: color-mix(in srgb, var(--pinepost-moss) 32%, var(--pinepost-paper-raised));
  border: 1px solid var(--pinepost-border);
  border-radius: var(--pinepost-radius-sm);
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1fr) auto auto auto;
  padding: 7px 9px;
}

.pinepost-upload__list button {
  background: transparent;
  border: 0;
  color: var(--pinepost-leaf-dark);
  cursor: pointer;
  font-family: var(--pinepost-font);
  font-weight: 900;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
}

.pinepost-upload__list span {
  color: var(--pinepost-muted);
  font-size: 0.78rem;
  font-weight: 900;
}

.pinepost-tree__row {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.pinepost-tree__row > input,
.pinepost-virtual-tree__row > input {
  accent-color: var(--pinepost-leaf);
  flex: 0 0 auto;
}

@media (max-width: 720px) {
  .pinepost-time-range-panel {
    grid-template-columns: 1fr;
  }

  .pinepost-transfer {
    grid-template-columns: 1fr;
  }

  .pinepost-transfer__actions {
    grid-template-columns: repeat(2, auto);
    justify-content: center;
  }

  .pinepost-cascader__panel,
  .pinepost-tree-select__panel,
  .pinepost-virtual-select__panel,
  .pinepost-mention__panel {
    left: 0;
    max-width: calc(100vw - 48px);
  }
}

@keyframes pinepost-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes pinepost-pop-in {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 8px)) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes pinepost-slide-in {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pinepost-skeleton-pulse {
  from {
    background-position: 220% 0;
  }
  to {
    background-position: -220% 0;
  }
}

@keyframes pinepost-spin {
  to {
    transform: rotate(360deg);
  }
}
